import { ApiError } from '@/api'

import { router } from './router'
import { useSessionStore } from './session-store'

/**
 * Any call answered 401 after sign-in means the session ended (idle or absolute
 * timeout, or a sign-out in another tab). Clear the user and show the session-ended page.
 */
export function endSessionOnUnauthorized(error: unknown): void {
  if (!(error instanceof ApiError) || error.problem.status !== 401) return
  const session = useSessionStore()
  if (session.status !== 'signed-in') return
  session.signOut()
  void router.push({ name: 'signed-out' })
}
